/**
 * Component to track authentication events from Clerk
 */

import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { trackLogin, trackSignUp } from '@/lib/analytics';

let hasTrackedInitialSession = false;

export const AuthAnalytics = () => {
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    // Only track when Clerk has fully loaded
    if (!isLoaded) return;

    // Track initial authentication state
    if (isSignedIn && !hasTrackedInitialSession) {
      // Check if this is a new user (createdAt is recent)
      const now = new Date();
      const createdAt = user?.createdAt ? new Date(user.createdAt) : null;
      const isNewUser = createdAt && (now.getTime() - createdAt.getTime()) < 5000; // Within 5 seconds

      if (isNewUser) {
        trackSignUp('email'); // Default to email, could be enhanced to detect actual method
      } else {
        trackLogin('email'); // Default to email, could be enhanced to detect actual method
      }

      hasTrackedInitialSession = true;
    }
  }, [isLoaded, isSignedIn, user]);

  return null; // This component doesn't render anything
};